var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAzureAd = function SvgAzureAd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#azure-ad_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BCF2",
    d: "M10.145 0 .473 11.6l9.672 8.4 9.382-8.436zm-.182 5.218A1.44 1.44 0 0 1 11.4 6.655c0 .353-.134.677-.346.927l2.128 2.473c.238-.178.534-.273.854-.273a1.44 1.44 0 0 1 1.437 1.436c0 .791-.646 1.418-1.437 1.418-.466 0-.865-.218-1.127-.563l-1.673 1.473c.1.194.164.402.164.636a1.44 1.44 0 0 1-1.437 1.436 1.44 1.44 0 0 1-1.436-1.436c0-.32.113-.616.291-.855l-1.255-1.145c-.261.282-.639.454-1.054.454a1.424 1.424 0 0 1-1.436-1.418 1.44 1.44 0 0 1 1.945-1.345l1.855-2.291a1.43 1.43 0 0 1-.346-.927c0-.792.645-1.437 1.436-1.437m-.69 2.691-1.8 2.255c.285.262.472.636.472 1.054 0 .198-.036.374-.109.546L9.163 13a1.43 1.43 0 0 1 .8-.254c.405 0 .776.166 1.037.436l1.69-1.51a1.3 1.3 0 0 1-.072-.454c0-.282.077-.56.218-.781l-2.2-2.528a1.4 1.4 0 0 1-.673.182c-.25 0-.486-.07-.69-.182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "azure-ad_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAzureAd;